import { isModuleEnabled, type ModuleKey, type AdminGate } from '@os/contracts/shared'

export interface AdminGateCtx {
  isGlobalAdmin: boolean
  isServerOwner: boolean
  /** server admin (owner / MANAGE_SERVER / ADMINISTRATOR) or global admin.
   *  Optional: absent ⇒ treated as false (e.g. the global-panel ctx). */
  isServerAdmin?: boolean
  enabledModules: Record<string, boolean> | null | undefined
}

/**
 * Whether an admin section's gate passes for the viewer. No gate ⇒ visible.
 * serverOwner is satisfied by a global admin too. moduleKey follows the
 * catalog default-enabled semantics (missing/undefined ⇒ enabled).
 */
export function passesAdminGate(gate: AdminGate | undefined, ctx: AdminGateCtx): boolean {
  if (!gate) return true
  if (gate.globalAdmin && !ctx.isGlobalAdmin) return false
  if (gate.serverOwner && !ctx.isServerOwner && !ctx.isGlobalAdmin) return false
  if (gate.serverAdmin && !ctx.isServerAdmin && !ctx.isGlobalAdmin) return false
  if (
    gate.moduleKey &&
    !isModuleEnabled(ctx.enabledModules as Partial<Record<ModuleKey, boolean>> | null | undefined, gate.moduleKey)
  ) {
    return false
  }
  return true
}
